(function() {
    "use strict";

    angular.module("app.cart").controller("CartController", CartController);

    CartController.$inject = ["$scope", "CartService"];

    function CartController($scope, CartService) {
        /* jshint validthis:true */
        var vm = this;

        vm.loading = false;

        vm.getCart = function() {
            vm.loading = true;
            CartService.getCart().then(function(_cart) {
                vm.cart = _cart;
                $scope.cart = _cart;
                angular.element(".mobile-badge").text(vm.cart.CartProduct.length);
                vm.loading = false;
            });
        };

        vm.InsertWithParams = function(params) {
            vm.loading = true;
            return CartService.InsertWithParams(params).then(function() {
                if (params.AddCartType !== "cart") {
                    vm.getCart();
                }
            });
        };

        vm.Increment = function(cartProduct) {
            vm.loading = true;
            CartService.Increment(cartProduct).then(function() {
                vm.getCart();
            });
        };

        vm.Decrement = function(cartProduct) {
            vm.loading = true;
            CartService.Decrement(cartProduct).then(function() {
                vm.getCart();
            });
        };

        vm.Delete = function(cartProduct) {
            vm.loading = true;
            CartService.Delete(cartProduct).then(function() {
                vm.getCart();
                $.Analytics.Removo_From_Cart(cartProduct.Product);
            });
        };

        vm.totalPriceWithDiscount = function() {
            if (!vm.cart) {
                return 0;
            }
            return _.sumBy(vm.cart.CartProduct, function(o) {
                return o.TotalPriceWithDiscount;
            });
        };

        vm.totalGroupPrice = function(groupedProducts) {
            return groupedProducts.reduce(function(sum, value) {
                return sum + value.Product.Price * value.Quantity;
            }, 0);
        };

        vm.totalGroupPriceWithDiscount = function(groupedProducts) {
            return groupedProducts.reduce(function(sum, value) {
                return sum + value.Product.PriceWithDiscount * value.Quantity;
            }, 0);
        };

        function activate() {
            vm.loading = false;
            vm.getCart();
        }

        activate();
    }
})();
